module.exports = __webpack_public_path__ + "static/1-58fe045e4524df40f24a3f259cb57720.jpg";